import { Dayjs } from 'dayjs'
import { immer } from 'zustand/middleware/immer'

import { getToday } from '~/astra'

import { Slice } from '../store'

type State = {
    selectedDate: Dayjs
}

const initialState: State = {
    selectedDate: getToday().endOf('month'), // End of this month
}

type Actions = {
    actions: {
        setSelectedDate: (date: Dayjs) => void
    }
}

export type InsightsSlice = {
    insights: State & Actions
}

export const createInsightsSlice: Slice<InsightsSlice> = immer(set => ({
    insights: {
        ...initialState,
        actions: {
            setSelectedDate: date =>
                set(state => {
                    state.insights.selectedDate = date
                }),
        },
    },
}))
